import { defineMessages } from '@atlassian/jira-intl';

const messages: {
	group: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	project: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	private: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	user: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	myOrganization: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	public: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	unknownProject: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	projectGalaxia: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	unknownProjectGalaxia: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	group: {
		id: 'shareable-entity-dialog.model.group',
		defaultMessage: 'Group',
		description:
			'Type picker option group, if the user picks this type, they will share the entity with a Jira group type i.e. Administrators',
	},
	project: {
		id: 'shareable-entity-dialog.model.project',
		defaultMessage: 'Project',
		description:
			'Type picker option project, if the user picks this type, they will share the entity with the collaborators of a Jira project',
	},
	private: {
		id: 'shareable-entity-dialog.model.private',
		defaultMessage: 'Private',
		description:
			"Type picker option private, if the user picks this type, they won't share the entity",
	},
	user: {
		id: 'shareable-entity-dialog.model.user',
		defaultMessage: 'User',
		description:
			'Type picker option user, if the user picks this type, they will share the entity will specified user',
	},
	myOrganization: {
		id: 'shareable-entity-dialog.model.my-organization',
		defaultMessage: 'My organization',
		description:
			'Type picker option Open, if the user picks this type, they will share the entity with everybody in the Jira Instance',
	},
	public: {
		id: 'shareable-entity-dialog.model.public',
		defaultMessage: 'Public',
		description:
			'Type picker option Public, if the user picks this type, they will share the entity with everybody, even anonymous users',
	},
	unknownProject: {
		id: 'shareable-entity-dialog.model.unknown-project',
		defaultMessage: 'Unknown project',
		description: 'UI placeholder for projects that the user does not have permissions to view',
	},
	projectGalaxia: {
		id: 'shareable-entity-dialog.model.project-galaxia',
		defaultMessage: 'Space',
		description:
			'Type picker option project, if the user picks this type, they will share the entity with the collaborators of a Jira project',
	},
	unknownProjectGalaxia: {
		id: 'shareable-entity-dialog.model.unknown-project-galaxia',
		defaultMessage: 'Unknown space',
		description: 'UI placeholder for projects that the user does not have permissions to view',
	},
});
export default messages;
